export default {
    ca: {
        title: 'Afegir col·laboradors',
        message: 'Escriu el correu electrònic de les persones que vols convidar a col·laborar en aquest mapa (màxim 10). En vermell s\'indiquen les persones que has convidat però no han confirmat la recepció de l\'e-mail.',
        esborrar: 'Duplicar',
        messageErrorLlistaConvidad: 'No s\'ha pogut carregar el llistat de convidats',
        messageErrorConvidad: 'No s\'ha pogut agregar el convidat',
        messageErrorEliminarConvidad: 'No s\'ha pogut eliminar el convidat',
        convidar: 'Convidar',
        emailPlaceholder: 'Correu',
        emailValidation: 'L\'email ha de ser vàlid',
        emailSubject: 'Mapa col·laboratiu a Instamaps. Invitació',
        emailContent: 'Et convido a col·laborar en el mapa ${nom} d\'Instamaps (creat per ${uid}). Clica a l\'enllaç per accedir-hi. Hauràs de registrar-te si no ho has fet encara. ${mapaUrl}',
        emailContent2:'  Els mapes col·laboratius no permeten que dos usuaris treballin alhora en un mateix mapa. El mapa queda bloquejat pel primer usuari que hi entra, fins que acaba el seu treball. Per tal de desbloquejar el mapa i permetre que altres usuaris hi puguin entrar, és molt important que, abans de tancar la finestra del vostre navegador, sortiu del mapa prement el botó "Desar/desbloquejar".',
        usrConvidats: 'Usuaris convidats',
        noConvidats: 'Aquest mapa no té convidats',
        mapaNoPublicat: 'Per convidar col·laboradors a aquest mapa, cal publicar-lo prèviament.',
    },
    es: {
        title: 'Añadir colaboradores',
        message: 'Escribe el correo electrónico de las personas que quieres invitar a colaborar en este mapa (máximo 10). En rojo se indican las personas que has invitado pero no han confirmado la recepción del e-mail.',
        esborrar: 'Duplicar',
        messageErrorLlistaConvidad: 'No se ha podido cargar el listado de invitados',
        messageErrorConvidad: 'No se ha podido agregar el invitado',
        messageErrorEliminarConvidad: 'No se ha podido eliminar el invitado',
        convidar: 'Invitar',
        emailPlaceholder: 'Correo',
        emailValidation: 'El email debe ser válido',
        emailSubject: 'Mapa colaborativo en Instamaps. Invitación',
        emailContent: 'Te invito a colaborar en el mapa ${nom} de Instamaps (creado por ${uid}). Haz clic en el enlace para acceder. Deberás registrarte si no lo has hecho todavía. ${mapaUrl}',
        emailContent2: 'Los mapas colaborativos no permiten que dos usuarios trabajen al mismo tiempo en un mismo mapa. El mapa queda bloqueado por el primer usuario que entra, hasta que termina su trabajo. Con el fin de desbloquear el mapa y permite que otros usuarios puedan entrar, es muy importante que, antes de cerrar la ventana de su navegador, salga del mapa pulsando el botón "Guardar / desbloquear".',
        usrConvidats: 'Usuarios invitados',
        noConvidats: 'Este mapa no tiene invitados',
        mapaNoPublicat: 'Para invitar colaboradores a este mapa, hay que publicarlo antes.',
    },
    en: {
        title: 'Add contributors',
        message: 'Write the email of the people you want to invite to collaborate on this map (maximum 10). In red the people you have invited but have not yet confirmed the reception of the e-mail.',
        esborrar: 'Duplicate',
        messageErrorLlistaConvidad: 'Could not load guest list',
        messageErrorConvidad: 'Could not add guest',
        messageErrorEliminarConvidad: 'The guest could not be deleted',
        convidar: 'Invite',
        emailPlaceholder: 'Email',
        emailValidation: 'Email must be valid',
        emailSubject: 'Collaborative map in Instamaps. Invitation',
        emailContent: 'I invite you to collaborate on the map ${nom} of Instamaps (created by ${uid}). Click on the link to access it. You will have to register if you have\'nt yet. ${mapUrl}',
        emailContent2: 'Collaborative maps do not allow two users to work on the same map at the same time. The map is blocked by the first user to enter it, until they finish their work. In order to unlock the map and allow other users to enter it, it is very important that, before closing your browser window, you exit the map by pressing the "Save / Unlock" button.',
        usrConvidats: 'Invited Users',
        noConvidats: 'This map has no invited users',
        mapaNoPublicat: 'To invite contributors to this map, you must publish it',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/colabora-modal/colabora-modal-translations.js